module.exports = __webpack_public_path__ + "static/media/demo2.e0b4ee3c.svg";